export const ELLIPSIS_LENGTH = 3
export const PaginationRowsOptions = [10, 20, 30]
export const SEARCH_WORD_LIMIT = 250
export const EXPORT_LIMIT = 10000
